module.exports = __webpack_public_path__ + "img/2c.ad34bff0.svg";